export default [
  {
    'text': '승인',
    'state': 'APPROVED'
  },
  {
    'text': '거절',
    'state': 'REJECTED'
  },
];



// WEBPACK FOOTER //
// ./src/api/reportState.js